import { inputDescLimit, inputTextLimit } from '../../../../helpers/fieldRestriction';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values.dynamicWhyHostInfoBlock && values.dynamicWhyHostInfoBlock.length > 0) {
    const dynamicWhyHostInfoBlockErrors = [];
    values.dynamicWhyHostInfoBlock.forEach((item, index) => {
      const itemErrors = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item.language || item.language.toString().trim() === '' || isLanguageInactive) {
        itemErrors.language = messages.required;
      }

      if (!item.whyBlockTitle1) {
        itemErrors.whyBlockTitle1 = messages.required;
      } else if (item.whyBlockTitle1.trim() == "") {
        itemErrors.whyBlockTitle1 = messages.required;
      } else if (item.whyBlockTitle1 && item?.whyBlockTitle1?.length > inputTextLimit) {
        itemErrors.whyBlockTitle1 = messages.inputTextLimitError;
      }

      if (!item.whyBlockTitle2) {
        itemErrors.whyBlockTitle2 = messages.required;
      } else if (item.whyBlockTitle2.trim() == "") {
        itemErrors.whyBlockTitle2 = messages.required;
      } else if (item.whyBlockTitle2 && item?.whyBlockTitle2?.length > inputTextLimit) {
        itemErrors.whyBlockTitle2 = messages.inputTextLimitError;
      }

      if (!item.whyBlockContent1) {
        itemErrors.whyBlockContent1 = messages.required;
      } else if (item.whyBlockContent1.trim() == "") {
        itemErrors.whyBlockContent1 = messages.required;
      } else if (item.whyBlockContent1 && item?.whyBlockContent1?.length > inputDescLimit) {
        itemErrors.whyBlockContent1 = messages.inputDescLimitError;
      }

      if (!item.whyBlockContent2) {
        itemErrors.whyBlockContent2 = messages.required;
      } else if (item.whyBlockContent2.trim() == "") {
        itemErrors.whyBlockContent2 = messages.required;
      } else if (item.whyBlockContent2 && item?.whyBlockContent2?.length > inputDescLimit) {
        itemErrors.whyBlockContent2 = messages.inputDescLimitError;
      }

      if (Object.keys(itemErrors).length > 0) {
        dynamicWhyHostInfoBlockErrors[index] = itemErrors;
      }
    });

    if (dynamicWhyHostInfoBlockErrors.length > 0) {
      errors.dynamicWhyHostInfoBlock = dynamicWhyHostInfoBlockErrors;
    }
  }

  return errors
}

export default validate;